module.exports = __webpack_public_path__ + "static/media/live-icon.a75575c1.svg";